"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionText = exports.OptionContainer = exports.Option = exports.ErrorMessage = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    display: flex;\n    flex-direction: column;\n    ", "\n    ", "\n"])), (0, _Utils.parseProp)('backgroundColor', 'background-color'), (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('width'));
const ErrorMessage = exports.ErrorMessage = _styledComponents.default.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    font-weight: 500;\n"])), (0, _Utils.parseTheme)('color', 'dangerColor'), (0, _Utils.parseProp)('fontSize', 'font-size'));
const Option = exports.Option = (0, _styledComponents.default)(_Utils.Button)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    align-items: center;\n    border-radius: 4px;\n    ", "\n    color: ", ";\n    display: flex;\n    flex: 1;\n    ", "\n    justify-content: left;\n    padding-left: 10px\n"])), _ref => {
  let {
    disabled
  } = _ref;
  return !disabled ? 'cursor: pointer;' : '';
}, _ref2 => {
  let {
    activeColor,
    checked,
    disabled,
    theme: {
      disabledColor,
      primaryColor,
      secondaryColor
    }
  } = _ref2;
  return disabled ? disabledColor : checked ? activeColor !== null && activeColor !== void 0 ? activeColor : primaryColor : secondaryColor;
}, (0, _Utils.parseProp)('fontSize', 'font-size'));
const OptionContainer = exports.OptionContainer = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n    display: flex;\n    ", "\n    flex-wrap: wrap;\n    ", "\n    ", "\n    ", "\n"])), _ref3 => {
  let {
    bordered,
    theme: {
      primaryLighterColor
    }
  } = _ref3;
  return bordered ? "\n        border: 1px solid ".concat(primaryLighterColor, ";\n        border-radius: 4px;\n    ") : '';
}, (0, _Utils.parseProp)('direction', 'flex-direction'), (0, _Utils.parseProp)('height'), (0, _Utils.parseProp)('margin'), (0, _Utils.parseProp)('padding'));
const OptionText = exports.OptionText = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n    margin-left: 3px;\n"])), (0, _Utils.parseProp)('color'));